import VaccinesIcon from '@mui/icons-material/Vaccines';
import { GoodsList } from './Goods.List';
import { GoodsCreate } from './Goods.Create';
import { GoodsEdit } from './Goods.Edit';
import { GoodsUpload } from './Goods.Upload';

export default {
    list: GoodsList,
    create: GoodsCreate,
    edit: GoodsEdit,
    upload: GoodsUpload,
    icon: VaccinesIcon,
};
